import { type FC } from 'react';

import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';
import SchoolOutlined from '@mui/icons-material/SchoolOutlined';

import { SideNavButton } from '@/src/components/atoms/navButtons';
import { Pages } from '@/src/config/pages';

import { NavDivider } from './NavDivider';
import { useLearnerRapsQueryData } from './useLearnerRapsQueryData';

export const LearnerNavLinks: FC = () => {
  const { raps } = useLearnerRapsQueryData();

  return (
    <>
      <NavDivider />
      <SideNavButton icon={SchoolOutlined} page='assigned-programs'>
        Programs
      </SideNavButton>
      {raps.length === 1 ? (
        <SideNavButton
          activePages={[
            'raps',
            'rap-assigned-learners',
            'rap-competencies',
            'rap-plan',
            'rap-program',
            'rap-level',
            'rap',
          ]}
          href={Pages.constructPath('rap', { rapId: raps[0].id })}
          icon={ReceiptLongOutlined}
        >
          RAP
        </SideNavButton>
      ) : (
        <SideNavButton
          activePages={[
            'raps',
            'rap-assigned-learners',
            'rap-competencies',
            'rap-plan',
            'rap-program',
            'rap-level',
            'rap',
          ]}
          icon={ReceiptLongOutlined}
          page='raps'
        >
          RAPs
        </SideNavButton>
      )}
      <NavDivider />
    </>
  );
};
